import React from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'
import sanitizeHtml from 'sanitize-html'

import { linkifyUrls } from 'utils'
import { body } from 'styles/texts'
import {
  messageSelector,
  messageAuthorNameSelector,
  messageTimeSelector,
  isMessageSelfSelector,
  messageAuthorProfilePictureSelector,
} from 'selectors'

import ProfilePictureComponent from 'components/ProfilePicture'

const Wrapper = styled.div`
  flex-shrink: 0;
  padding-top: 10px;
  display: flex;
  flex-direction: column;
  align-self: ${props => (props.isSelf ? 'flex-end' : 'flex-start')};
  justify-content: ${props => (props.isSelf ? 'flex-end' : 'flex-start')};
`

const Top = styled.div`
  display: flex;
  justify-content: ${props => (props.isSelf ? 'flex-end' : 'flex-start')};
`

const Text = styled.div`
  max-width: 500px;
  padding: 7px 13px 11px;
  background-color: #f2f2f2;
  border-radius: 10px;
  order: ${props => (props.isSelf ? '-1' : '0')};
  margin-left: ${props => (props.isSelf ? '0' : '10px')};
  margin-right: ${props => (props.isSelf ? '10px' : '0')};
`

const ProfilePicture = styled(ProfilePictureComponent)`
  flex-shrink: 0;
`

const Metadata = styled.div`
  ${body};
  color: #9b9b9c;
  text-align: ${props => (props.isSelf ? 'end' : 'start')};
  margin-left: ${props => (props.isSelf ? '0' : '40px')};
  margin-right: ${props => (props.isSelf ? '40px' : '0')};
`

const Message = ({ isSelf, message, name, time, profilePicture }) => (
  <Wrapper isSelf={isSelf}>
    <Top isSelf={isSelf}>
      <ProfilePicture src={profilePicture} size="30" />
      <Text
        isSelf={isSelf}
        dangerouslySetInnerHTML={{ __html: sanitizeHtml(linkifyUrls(message)) }}
      />
    </Top>
    <Metadata isSelf={isSelf}>
      {isSelf ? 'Du' : name} • {time}
    </Metadata>
  </Wrapper>
)

const mapStateToProps = (state, { roomId, messageId }) => ({
  ...(messageSelector(state, roomId, messageId) || {}),
  name: messageAuthorNameSelector(state, roomId, messageId),
  profilePicture: messageAuthorProfilePictureSelector(state, roomId, messageId),
  time: messageTimeSelector(state, roomId, messageId),
  isSelf: isMessageSelfSelector(state, roomId, messageId),
})

export default connect(mapStateToProps)(Message)



// WEBPACK FOOTER //
// ./src/components/chat/Message.js